import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SalesProducts } from './sales-products.model';
import { SALES_PRODUCTS_FEATURE_KEY, SalesProductsState } from './sales-products.reducer';

export const selectSalesProductsState = createFeatureSelector<SalesProductsState>(SALES_PRODUCTS_FEATURE_KEY);

export const selectSalesProductsLoaded = createSelector(
  selectSalesProductsState,
  (state: SalesProductsState) => state.loaded
);

export const selectSalesProducts = createSelector(
  selectSalesProductsState,
  (state: SalesProductsState) => state.salesProducts
);

export const selectSalesProductsError = createSelector(
  selectSalesProductsState,
  (state: SalesProductsState) => state.error
);

export const selectHasApiToken = createSelector(
  selectSalesProducts,
  (salesProducts: SalesProducts | undefined) => salesProducts?.hasApiToken
);
export const selectHasScanUserAccess = createSelector(
  selectSalesProducts,
  (salesProducts: SalesProducts | undefined) => salesProducts?.hasScanUserAccess
);
